import { render, staticRenderFns } from "./NotificationsDropdown.vue?vue&type=template&id=4801c61a&scoped=true&"
import script from "./NotificationsDropdown.vue?vue&type=script&lang=ts&"
export * from "./NotificationsDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsDropdown.vue?vue&type=style&index=0&id=4801c61a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4801c61a",
  null
  
)

export default component.exports